import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutCustomerAsync } from '../store/slices/customerAuthSlice';
import { AppDispatch } from '../store/store';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  Divider,
} from '@mui/material';
import { CloudUpload, Person, PersonAdd, Login, Dashboard, Logout } from '@mui/icons-material';
import { RootState } from '../store/store';
import { sanitizeText } from '../utils/sanitize';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { isAuthenticated: isCustomerAuthenticated, user: customerUser } = useSelector(
    (state: RootState) => state.customerAuth
  );

  const handleLogout = () => {
    // Call server to clear httpOnly cookies, then clear client state
    dispatch(logoutCustomerAsync());
    navigate('/');
  };

  return (
    <AppBar position="static" color="default" elevation={1}>
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <CloudUpload sx={{ mr: 1, color: 'primary.main' }} />
          <Typography
            variant="h6"
            component={RouterLink}
            to="/"
            sx={{
              flexGrow: 1,
              textDecoration: 'none',
              color: 'inherit',
              fontWeight: 'bold',
            }}
          >
            SupportLogs.IO
          </Typography>

          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {/* Customer authentication buttons */}
            {!isCustomerAuthenticated ? (
              <>
                <Button
                  component={RouterLink}
                  to="/register"
                  startIcon={<PersonAdd />}
                  variant="text"
                  size="small"
                  color="primary"
                >
                  Sign Up
                </Button>
                <Button
                  component={RouterLink}
                  to="/customer/login"
                  startIcon={<Login />}
                  variant="contained"
                  size="small"
                  color="primary"
                >
                  Customer Login
                </Button>
              </>
            ) : (
              <>
                <Typography variant="body2" sx={{ mr: 1 }}>
                  Welcome, {sanitizeText(customerUser?.firstName) || 'Customer'}
                </Typography>
                <Button
                  component={RouterLink}
                  to="/customer/dashboard"
                  startIcon={<Dashboard />}
                  variant="text"
                  size="small"
                  color="primary"
                >
                  Dashboard
                </Button>
                <Button
                  onClick={handleLogout}
                  startIcon={<Logout />}
                  variant="outlined"
                  size="small"
                  color="inherit"
                >
                  Logout
                </Button>
              </>
            )}

            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

            {/* Engineer login button */}
            <Button
              component={RouterLink}
              to="/login"
              startIcon={<Person />}
              variant="outlined"
              size="small"
              color="inherit"
            >
              Engineer Login
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
